export default "__VITE_ASSET__483d2241__"